import React, { useEffect } from "react";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const SwingingSVG = () => {
  useEffect(() => {
    gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

    // Create the swinging animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".swinging-svg",
        start: "top top",
        end: "bottom bottom",
        scrub: 1,
      },
    });

    tl.to(".swinging-svg", {
      duration: 2,
      motionPath: {
        path: "M120 0 Q180 50 120 100 Q60 150 120 200 T120 300",
        align: "self",
        autoRotate: true,
      },
      ease: "power1.inOut",
    });
  }, []);

  return (
    <div className="swinging-svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="240"
        height="147"
        viewBox="0 0 240 147"
        fill="none"
      >
        <path
          d="M233.968 147L239.636 136.94L228.089 137.061L233.968 147ZM0 0C0 1.59823 0.0411781 3.16893 0.123554 4.71229L2.12071 4.6057C2.04029 3.09902 2 1.56389 2 0H0ZM1.18982 14.0871C1.76071 17.2779 2.53709 20.3341 3.51901 23.2577L5.41493 22.6209C4.46573 19.7948 3.71304 16.8339 3.15855 13.7348L1.18982 14.0871ZM7.25464 31.9604C8.74386 34.7586 10.4609 37.4081 12.4043 39.9116L13.9841 38.6852C12.1104 36.2714 10.4555 33.7178 9.02018 31.0208L7.25464 31.9604ZM18.8078 46.8904C21.0656 48.9879 23.5225 50.9557 26.1767 52.7972L27.3168 51.1539C24.736 49.3634 22.3536 47.4546 20.1691 45.4252L18.8078 46.8904ZM34.2361 57.6864C36.9237 59.1126 39.7657 60.4416 42.7608 61.676L43.5229 59.8268C40.5832 58.6153 37.8001 57.3135 35.1736 55.9197L34.2361 57.6864ZM51.597 64.9029C54.4786 65.8326 57.4781 66.6912 60.5948 67.4802L61.0857 65.5414C58.0075 64.7621 55.0493 63.9152 52.2111 62.9995L51.597 64.9029ZM69.7352 69.5303C72.7181 70.1193 75.7946 70.654 78.9642 71.1354L79.2646 69.1581C76.1222 68.6808 73.0749 68.1511 70.1227 67.5681L69.7352 69.5303ZM88.2313 72.362C91.2551 72.7066 94.3551 73.0085 97.5308 73.2684L97.694 71.2751C94.5382 71.0168 91.4594 70.7169 88.4578 70.3748L88.2313 72.362ZM106.875 73.9012C109.917 74.0663 113.024 74.1969 116.194 74.2934L116.255 72.2943C113.1 72.1983 110.009 72.0684 106.983 71.9042L106.875 73.9012ZM125.52 74.4778C127.071 74.4926 128.637 74.5 130.217 74.5V72.5C128.643 72.5 127.084 72.4926 125.539 72.4779L125.52 74.4778ZM130.217 74.5C131.727 74.5 133.217 74.5154 134.685 74.5459L134.727 72.5463C133.244 72.5156 131.741 72.5 130.217 72.5V74.5ZM143.506 74.9221C146.524 75.1197 149.446 75.3844 152.275 75.7121L152.505 73.7254C149.642 73.3938 146.687 73.126 143.637 72.9264L143.506 74.9221ZM161.043 76.9753C164.037 77.4954 166.914 78.0907 169.679 78.755L170.146 76.8103C167.339 76.1359 164.42 75.5319 161.385 75.0048L161.043 76.9753ZM178.164 81.1138C181.06 82.0351 183.814 83.0379 186.432 84.1125L187.191 82.2623C184.522 81.1666 181.717 80.1453 178.77 79.2079L178.164 81.1138ZM194.415 87.8179C197.107 89.2238 199.626 90.7118 201.982 92.2674L203.084 90.5983C200.67 89.0047 198.092 87.4821 195.341 86.0452L194.415 87.8179ZM209.02 97.4949C211.343 99.4345 213.463 101.444 215.395 103.5L216.853 102.131C214.866 100.016 212.687 97.9511 210.302 95.9597L209.02 97.4949ZM220.966 110.239C222.74 112.689 224.285 115.171 225.622 117.653L227.383 116.704C226.005 114.147 224.413 111.589 222.586 109.066L220.966 110.239ZM229.236 125.604C230.308 128.466 231.124 131.278 231.717 133.984L233.671 133.556C233.057 130.758 232.215 127.856 231.109 124.903L229.236 125.604Z"
          fill="red"
        />
      </svg>
    </div>
  );
};

export default SwingingSVG;
